import { useEffect, useRef, useState } from "react";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";
import { MessagesProvider } from "../context/MessagesContext";
import { Tooltip, useMediaQuery } from "@mui/material";
import { theme } from "../theme";

const MainLayout = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [isSidebarExpanded, setIsSidebarExpanded] = useState(!isMobile);
  const sidebarCarrotRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseEnter = () => {
      const drawer = document.querySelector(".MuiDrawer-paperAnchorDockedLeft");
      if (drawer) {
        // @ts-ignore
        drawer.style.opacity = "0.6";
      }
    };

    const handleMouseLeave = () => {
      const drawer = document.querySelector(".MuiDrawer-paperAnchorDockedLeft");
      if (drawer) {
        // @ts-ignore
        drawer.style.opacity = "";
      }
    };

    const sidebarCarrot = sidebarCarrotRef.current;
    if (sidebarCarrot) {
      sidebarCarrot.addEventListener("mouseenter", handleMouseEnter);
      sidebarCarrot.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (sidebarCarrot) {
        sidebarCarrot.removeEventListener("mouseenter", handleMouseEnter);
        sidebarCarrot.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, []);

  return (
    <MessagesProvider>
      <Tooltip
        title={`${isSidebarExpanded ? "Close" : "Open"} Sidebar`}
        placement="right"
      >
        <div
          ref={sidebarCarrotRef}
          onClick={() => {
            setIsSidebarExpanded(prev => !prev);
          }}
          className={`${
            isMobile ? "hidden" : "block"
          } fixed left-0 top-1/2 z-40 left-sidebar-carrot  ${
            !isSidebarExpanded ? "-ml-[250px] closed" : ""
          }`}
        >
          <button>
            <span>
              <div className="flex h-[88px] w-8 items-center justify-center sidebar-carrot-inner">
                <div className="flex h-6 w-6 flex-col items-center">
                  <div className="h-3 w-1 rounded-full bg-black translator-a"></div>
                  <div className="h-3 w-1 rounded-full bg-black translator-b"></div>
                </div>
              </div>
            </span>
          </button>
        </div>
      </Tooltip>

      <div className="flex w-full h-screen">
        <Sidebar
          isMobile={false}
          drawerOpen={isSidebarExpanded}
          setDrawerOpen={setIsSidebarExpanded}
        />
        {isMobile && isSidebarExpanded && (
          <div
            onClick={() => setIsSidebarExpanded(false)}
            className="fixed inset-0 z-40 bg-black/50 transition-opacity"
          />
        )}

        {/* Outlet container */}
        <div className="flex-grow overflow-auto dark:bg-background/paper-elevation-1 z-0">
          <Outlet context={{ isSidebarExpanded, setIsSidebarExpanded }} />
        </div>
      </div>
    </MessagesProvider>
  );
};

export default MainLayout;
